var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_887_1604)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.99989 16.1701L5.52989 12.7001C5.13989 12.3101 4.50989 12.3101 4.11989 12.7001C3.72989 13.0901 3.72989 13.7201 4.11989 14.1101L8.29989 18.2901C8.68989 18.6801 9.31989 18.6801 9.70989 18.2901L20.2899 7.71007C20.6799 7.32007 20.6799 6.69007 20.2899 6.30007C19.8999 5.91007 19.2699 5.91007 18.8799 6.30007L8.99989 16.1701Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_887_1604"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.d7dc62bc6b042b212fd5d4ce51fe416b.svg";
export { ForwardRef as ReactComponent };